import { Pipe, PipeTransform } from '@angular/core';
import { IfStmt } from '@angular/compiler';

@Pipe({
  name: 'transformarTexto'
})
export class TransformarTextoPipe implements PipeTransform {

  transform(nombreArticulo: string, cantMax: number) {
    let valorFinal = '';

    if (nombreArticulo.length > cantMax) {
      valorFinal = nombreArticulo.substr(0, cantMax - 1) + '...';
    } else {
      valorFinal = nombreArticulo;
    }
    return valorFinal;
  }
}
